'use client'
import Plebiscito from '@plebiscito/plebiscito'

export default Plebiscito
